export const defaultLabels: {[key: string]: string} = {
  AllActive: 'All active candidates',
  WaitingForCandidate: 'Waiting for candidate',
  NoSurveysComplete: 'No surveys complete',
  OnePlusSurveysComplete: '1+ surveys complete',
  AllSurveysComplete: 'All surveys complete',
  AllInactive: 'All inactive candidates',
  InactiveHired: 'Hired',
  InactiveHibernate: 'Not hired',

  AllPositions: 'All positions',
  AllActivePositions: 'All active positions',
  Incomplete: 'Incomplete',
  PartiallyComplete: 'Partially complete',
  Complete: 'Complete',
  InactivePositions: 'Inactive positions',

  Archived: 'Archived Prospects',
  Active: 'New Prospects'
};
